<p-toast position="bottom-center"></p-toast>

<div class="card md-form-shell">
  <form
    [formGroup]="businessForm"
    novalidate
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="off"
    (ngSubmit)="saveBusiness()"
  >
    <div class="card-container bg-gray-100 border-round mt-2 p-4">
      <div class="mr-5 flex align-items-center mb-3">
        <i class="pi pi-briefcase mr-2 text-3xl"></i>
        <div class="font-medium text-3xl text-900">{{ pageTitle }}</div>
      </div>

      <div class="grid formgrid p-fluid">
        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-building"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="businessName"
                id="businessName"
                class="w-full"
                placeholder="Enter business name"
              />
              <label for="businessName">Business Name</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="businessCode"
                id="businessCode"
                class="w-full"
                placeholder="Enter business code"
              />
              <label for="businessCode">Business Code</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <app-entity-dropdown-picker
          formControlName="businessUnit"
          [adapter]="businessUnitPickerAdapter"
          inputId="businessUnit"
          label="Business Unit"
          placeholder="Select a Business Unit"
          filterPlaceholder="Filter business units"
          columnClass="col-12 md:col-6"
          addonIconClass="pi pi-sitemap"
        ></app-entity-dropdown-picker>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-wallet"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="arAccount"
                id="arAccount"
                class="w-full"
                placeholder="Enter AR account"
              />
              <label for="arAccount">AR Account</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-wallet"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="apAccount"
                id="apAccount"
                class="w-full"
                placeholder="Enter AP account"
              />
              <label for="apAccount">AP Account</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-link"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="reference"
                id="reference"
                class="w-full"
                placeholder="Enter reference"
              />
              <label for="reference">Reference</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>
      </div>
    </div>

    <div class="mt-4 flex justify-content-end gap-2">
      <p-button
        label="Cancel"
        styleClass="p-button-secondary"
        type="button"
        (onClick)="cancel()"
      ></p-button>
      <p-button
        [label]="isEditMode ? 'Update Business' : 'Save Business'"
        type="submit"
        [disabled]="businessForm.invalid"
      ></p-button>
    </div>
  </form>
</div>
